import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class FeatureSwitchGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var featureSwitchGrid = this;
		setTimeout(function(){
			featureSwitchGrid.init();
		});
	}
	
	render() {	
		return html`
			<style>				
			</style>
			<slot></slot>		
		`;
	}

	init() {
		var featureSwitchGrid = this;
		
		
		
		var actionRefresh = function() {
			ElementUtil.removeAllChildren(featureSwitchGrid);
			
			var styleBlock = ElementUtil.create({
				tag: 'style',
				innerHTML: `
				.featureblock {
					border: 1px solid lightgrey;
					margin: 20px; 
					padding: 10px;
					border-radius: 5px 5px 5px 5px;
					box-shadow: black 5px 5px 10px;
				}
			
				.enabled-feature {
					color: white;
					background-color: #598459;
				}
			
				.disabled-feature {
					color: white;
					background-color: #4b4444;
				}
			`
			});
			featureSwitchGrid.append(styleBlock);
			
			var loadMask = DL.MessageUtil.fullPageLoadMask();
			//get Active features
			Service.getFeatureSwitchService().getSwitches({status: 'A'}).then(function (switches) {
				loadMask.opened = false;

				if (switches.data.length === 0) {
					var noFeatureSwitch = ElementUtil.create({
						tag: 'div',
						'class': 'alert alert-warning',
						style: 'text-align: center',
						trustedInnerHTML: true,
						innerHTML: "<i class='fas fa-2x fa-exclamation-triangle'></i> No feature switches are active"
					});
					featureSwitchGrid.append(noFeatureSwitch);

				} else {

					switches.data.forEach(function (feature) {

						var toggleSwitchConfig = {
							tag: 'dl-toggle-switch',
							style: 'float: right; margin-right: 50px;',
							listeners: {
								'value-change': function (e) {
									actionRecordNewState(feature, e.detail.value);
								}
							}
						};
						if (feature.enabled) {
							toggleSwitchConfig.checked = true;
						}

						var featureBlock = ElementUtil.create({
							tag: 'div',
							'class': 'featureblock ' + (feature.enabled ? 'enabled-feature' : 'disabled-feature'),
							style: '',
							children: [
								{
									tag: 'h2',
									innerHTML: feature.featureTypeDescription
								},
								{
									tag: 'div',
									innerHTML: 'Comment: ' + feature.comment
								},
								{
									tag: 'div',
									children: [
										{
											tag: 'vaadin-button',
											children: [
												ElementUtil.makeIcon('vaadin:records', ' History')
											],
											listeners: {
												click: function () {
													actionShowHistory(feature);
												}
											}
										},
										toggleSwitchConfig
									]
								}
							]
						});
						featureSwitchGrid.append(featureBlock);

					});
				}

			});
		};
		actionRefresh();
		
		var actionShowHistory = function(feature) {
			var historyWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'History',
				icon: 'vaadin:records',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						historyWin.show();
												
						
						var historyGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [									
								{						
									path: 'featureTypeDescription',
									header: 'Feature Type',									
									width: '7em'
								},
								{						
									path: 'comment',
									header: 'Comment',									
									width: '7em'
								},
								{						
									path: 'enabled',
									header: 'Enabled',									
									width: '7em'
								},
								{						
									path: 'createDts',
									header: 'Create Date',									
									width: '7em',
									renderer: function(root, column, rowData) {	
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.createDts);
									}
								},								
								{						
									path: 'createUser',
									header: 'Create User',									
									width: '7em'
								},
								{						
									path: 'updateDts',
									header: 'Update Date',									
									width: '7em',
									renderer: function(root, column, rowData) {	
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.updateDts);
									}
								},								
								{						
									path: 'updateUser',
									header: 'Update User',									
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									historyGrid.selectedItems = item ? [item] : [];
					
								}
							}
						});						
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								historyGrid
							]
						});	
						
						historyWin.addToContentElement(layout);						
						
						var actionRefreshHistory = function() {
							var loadMask = historyGrid.showLoading();				
							
							var filter = {
								status: 'I', 
								filterField: 'featureType',
								filterValue: feature.featureType
							};
							
							Service.getFeatureSwitchService().getSwitches(filter).then(function (switches) {
								loadMask.remove();
								
								historyGrid.activeItem = null;						
								historyGrid.items = switches.data;
							});							
						};
						actionRefreshHistory();
						
					}
				}
			});
		};
		
		var actionRecordNewState = function(feature, enabled) {
			
			//prompt for comment
			var promptWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Update State',
				icon: 'vaadin:edit',				
				width: 400,
				height: 200,
				listeners: {
					ready: function() {						
						promptWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [										
										{
											tag: 'vaadin-text-field',
											label: 'Comment',
											name: 'comment',
											required: true,
											maxlength: 255
										},									
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {

															if (formPanel.isValid()) {
																var data = formPanel.getData();																
																actionUpdate(data.comment);
																promptWin.close();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															actionRefresh();
															
															//cancel
															promptWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						promptWin.addToContentElement(formPanel);
						
						
						var actionUpdate = function(comment) {
							var loadMask = DL.MessageUtil.fullPageLoadMask('Saving new state...');
			
							var newState = {
								featureId: feature.featureId,
								featureType: feature.featureType,
								enabled: enabled,
								comment: comment
							};

							Service.getFeatureSwitchService().setSwitchState(newState).then(function(){
								loadMask.opened = false;

								window.DL.MessageUtil.showToast('Success', 'Updated state', {									
									theme: 'success'
								});
								
								actionRefresh();				
							}).catch(function(){
								loadMask.opened = false;

								window.DL.MessageUtil.showToastError('Failed to update state');
								actionRefresh();
							});
						};
					}
				}
			});
			
		};
		
	}
	
}
customElements.define('dl-feature-switches', FeatureSwitchGrid);


